import React from "react";
import styled from "styled-components";

import { colors, fonts } from "./theme";

import Logo from "../assets/w_logo.svg";

const LOADING_DURATION = 1000;
const LoadingOverlay = styled.div.attrs({
  children: <div><Logo /><br/>We’re sorry!<br/>The Mosaic app and its content is no longer available.<br/>The <a href="https://www.hbo.com/mosaic/">linear version of Mosaic</a> can still be viewed on <a href="https://play.hbogo.com">HBO Go</a> and <a href="https://play.hbonow.com">HBO Now</a>.<br/>To learn about exciting upcoming experiences from PodOp, sign up for our mailing list at <a href="https://www.podop.com">www.podop.com</a>.</div>,
})`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  background: ${colors.black};
  transition: opacity ${LOADING_DURATION}ms ease-in-out;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${fonts.book};
  font-size: 17px; 
  line-height: 24px;
  
  a {
    color: ${colors.primary};
  }

  & svg {
    backface-visibility: hidden;
    transition: transform 3s ease-in-out;
    width: 80%;
    max-width: 400px;
    height: auto;

    fill: white;
    transform: translateZ(0) scale(${props => (props.isVisible ? 1 : 0.6)});
  }
`;

export default class Loader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isGone: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isVisible) {
      setTimeout(() => {
        if (this && this.state && !this.state.isGone) {
          this.setState({ isGone: true });
        }
      }, LOADING_DURATION);
    } else {
      this.setState({ isGone: false });
    }
  }

  render() {
    return (
      !this.state.isGone && <LoadingOverlay isVisible={this.props.isVisible} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Loader.js